
// Time utilities

export function renderTimeSeconds(s: number): string {
    if (isNaN(s) || !isFinite(s) || s < 0) {
        s = 0;
    }
    s = Math.floor(s);
    let hours = 0;
    let minutes = 0;
    if (s >= 3600) {
        hours = Math.floor(s / 3600);
        s = s % 3600;
    }
    if (s > 60) {
        minutes = Math.floor(s / 60);
        s = s % 60;
    }
    let r = "";

    if (s > 9) {
        r = "" + s + r;
    } else {
        r = "0" + s + r;
    }

    if (minutes > 9) {
        r = "" + minutes + ":" + r;
    } else {
        r = "0" + minutes + ":" + r;
    }

    if (hours > 0) {
        if (hours > 9) {
            r = "" + hours + ":" + r;
        } else {
            r = "0" + hours + ":" + r;
        }
    }

    return r;
}

function normalizeTimestamp(timestamp: number): number {
    if (!timestamp || timestamp === 0) return 0;
    
    if (timestamp > 0 && timestamp < 946684800000) {
        return timestamp * 1000;
    }
    
    return timestamp;
}

export function renderDate(date: Date | string | number, $t: (t: string) => string) {
    if (!date) return "-";
    
    if (typeof date === "string" || typeof date === "number") {
        if (typeof date === "number") {
            date = normalizeTimestamp(date);
        }
        
        date = new Date(date);
        
        if (isNaN(date.getTime())) {
            return "-";
        }
    }

    const template = $t("[m] [d], [y]");
    const months = [
        $t("January"), $t("February"), $t("March"), $t("April"), 
        $t("May"), $t("June"), $t("July"), $t("August"), 
        $t("September"), $t("October"), $t("November"), $t("December")
    ];

    const y = date.getFullYear();
    const d = date.getDate();
    
    let m = date.getMonth();
    
    if (m < 0) {
        m = 0;
    } else if (m >= months.length) {
        m = months.length - 1;
    }

    return template
        .replace("[m]", months[m])
        .replace("[d]", d.toString())
        .replace("[y]", y.toString());
}

export function renderDateAndTime(date: Date | string | number, $t: (t: string) => string) {
    if (!date) return "-";
    
    if (typeof date === "string" || typeof date === "number") {
        if (typeof date === "number") {
            date = normalizeTimestamp(date);
        }
        
        date = new Date(date);
        
        if (isNaN(date.getTime())) {
            return "-";
        }
    }

    const template = $t("[m] [d], [y] [hh]:[mm]:[ss]");
    const months = [
        $t("January"), $t("February"), $t("March"), $t("April"), 
        $t("May"), $t("June"), $t("July"), $t("August"), 
        $t("September"), $t("October"), $t("November"), $t("December")
    ];

    const y = date.getFullYear();
    const d = date.getDate();

    let m = date.getMonth();
    
    if (m < 0) {
        m = 0;
    } else if (m >= months.length) {
        m = months.length - 1;
    }

    const hh = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    const ss = date.getSeconds().toString().padStart(2, '0');

    return template
        .replace("[m]", months[m])
        .replace("[d]", d.toString())
        .replace("[y]", y.toString())
        .replace("[hh]", hh)
        .replace("[mm]", mm)
        .replace("[ss]", ss);
}

export function renderCompactDateAndTime(date: Date | string | number, $t: (t: string) => string) {
    if (!date) return "-";
    
    if (typeof date === "string" || typeof date === "number") {
        if (typeof date === "number") {
            date = normalizeTimestamp(date);
        }
        
        date = new Date(date);
        
        if (isNaN(date.getTime())) {
            return "-";
        }
    }

    const shortMonths = [
        $t("Jan"), $t("Feb"), $t("Mar"), $t("Apr"), 
        $t("May"), $t("Jun"), $t("Jul"), $t("Aug"), 
        $t("Sep"), $t("Oct"), $t("Nov"), $t("Dec")
    ];

    const y = date.getFullYear().toString().slice(2); // Get last 2 digits of year
    const d = date.getDate().toString().padStart(2, '0');
    
    let m = date.getMonth();
    if (m < 0) {
        m = 0;
    } else if (m >= shortMonths.length) {
        m = shortMonths.length - 1;
    }
    
    const hh = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');

    // Format: "DD-MMM-YY HH:MM" (e.g., "15-Jan-25 14:30")
    return `${d}-${shortMonths[m]}-${y} ${hh}:${mm}`;
}
